import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { profileAction, userAction } from "@redux/modules";

import { FaHeart } from 'react-icons/fa';

// Format Date
import moment from 'moment';

const CharityScore = () => {
  const dispatch = useDispatch();
  // İyilik Puanı Geçmişi
  const pointHistoryAll = useSelector((store) => store.profile.charityScore);
  const totalCharityScore = useSelector(
    (store) => store.profile.profileDetail?.charityScore
  ); // Toplam puanı almak için

  console.log(totalCharityScore);

  const [state, setState] = useState({
    transactionsCount: 10,
  });

  useEffect(() => {
    dispatch(profileAction.getCharityScore());
  }, []);

  const handleLoadMore = (event) => {
    event.preventDefault();
    setState({
      ...state,
      transactionsCount:
        (state.transactionsCount ? state.transactionsCount : 10) + 10,
    });
  };

  return (
    <>
      <React.Fragment>
        <div className="d-flex align-items-center justify-content-between mb-sm-6 mb-4">
          <h2 className="mb-0">İyilik Puanı Geçmişim</h2>
          <span className="badge rounded-pill bg-blue px-3 py-2 fs-6">
            Toplam Puan: <FaHeart className="text-white" /> {totalCharityScore || 0}
          </span>
        </div>
        <p className="mb-sm-5 mb-4 fw-light">
          Kazandığınız iyilik puanlarını bu bölümde detaylı olarak görebilir,
          takip edebilirsiniz.
        </p>

        {pointHistoryAll && pointHistoryAll.content?.length > 0 ? (
          pointHistoryAll.content
            ?.slice(0, state.transactionsCount ? state.transactionsCount : 10)
            .map((item, i) => (
              <div
                className="d-flex align-items-center justify-content-between py-3 border-bottom"
                key={i}
              >
                <span className="text-blue-light">
                  {moment(item.dateCreated).format("DD.MM.YYYY - HH:mm")}
                </span>
                <span className="mx-4">{item.scoreTypeName}</span>
                {item.scoreType === "SIPARIS" ? (
                  <span className="badge rounded-pill bg-red px-3 py-2 ms-auto">
                    -{item.changedScore} İyilik Puanı
                  </span>
                ) : (
                  <span className="badge rounded-pill bg-green px-3 py-2 ms-auto">
                    +{item.changedScore} İyilik Puanı
                  </span>
                )}
              </div>
            ))
        ) : (
          <div className="text-center py-5">
            <h3 className="mb-3">Henüz İyilik Puanınız Bulunmuyor</h3>
            <p className="text-muted">
              Sipariş vererek ve platformdaki aktivitelerinizle iyilik puanı
              kazanmaya başlayabilirsiniz.
              <br />
              Her iyilik size puan olarak geri dönecek!
            </p>
          </div>
        )}

        {pointHistoryAll?.content?.length -
          (state.transactionsCount ? state.transactionsCount : 10) >
        0 ? (
          <div className="text-center mt-sm-6 mt-5">
            <button
              type="button"
              className="btn btn-blue rounded-pill py-sm-3 py-2 px-sm-4 px-3"
              onClick={(event) => handleLoadMore(event)}
            >
              Daha Fazla Göster
            </button>
          </div>
        ) : null}
      </React.Fragment>
    </>
  );
};

export default CharityScore;
